import cn from "classnames";
import { ProgressLineProps, ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { ArrowRightLongIcon } from "shared/ui/Icons";
import styles from "./ProgressLine.module.scss";

export const ProgressLine: RFC<ProgressLineProps & { shipmentType: ValueOf<typeof ShipmentType> }> = ({
  percent,
  status,
  rotation,
  className,
  shipmentType,
}) => {
  const pointAStyles: string =
    status === "location-data"
      ? rotation === "vertical" && percent === 0
        ? cn(styles.point, styles.pointA, styles.disabled)
        : cn(styles.point, styles.pointA)
      : cn(styles.point, styles.pointA, styles.disabled);
  const pointBStyles: string =
    percent >= 100 ? cn(styles.point, styles.pointB) : cn(styles.point, styles.pointB, styles.disabled);

  return (
    <div
      className={cn(styles.progress, styles[status], styles[rotation], styles[shipmentType.toLowerCase()], className)}
    >
      <div className={pointAStyles} />

      <div className={cn(styles.empty, styles.progressLine)} />

      {percent !== 0 && (
        <div
          className={cn(styles.filled, styles.progressLine)}
          style={rotation === "vertical" ? { height: `${percent}%` } : { width: `${percent}%` }}
        >
          {percent < 100 && (
            <div className={cn(styles.point, styles.pointCurrent)}>
              <ArrowRightLongIcon />
            </div>
          )}
        </div>
      )}

      <div className={pointBStyles} />
    </div>
  );
};

ProgressLine.displayName = ProgressLine.name;
